import { useAppSelector } from '@redux/hooks';
import { selectCurrentExperience } from '@redux/selectors';
import { mainInfo } from '@consts';
import { useCallback } from 'react';

export const useGetActiveStackItem = () => {
  const clickedPosition = useAppSelector(selectCurrentExperience);
  const currentStackNamesList =
    mainInfo.EXPERIENCE_INFO.find(
      (one) => one.id === clickedPosition,
    )?.stack?.map((one) => one.name) ?? [];

  return useCallback(
    (stackName: string): boolean => currentStackNamesList.includes(stackName),
    [clickedPosition],
  );
};
